import "../styles/components/_header-burger.scss";
import headerHtml from "../../public/partials/header.html";

const NAV_ITEMS = [
  { href: "our-work.html", label: "Our work" },
  { href: "services.html", label: "Services & solutions" },
  { href: "about.html", label: "About us" },
];

const currentPage = (): string => {
  const path = window.location.pathname;
  const file = path.substring(path.lastIndexOf("/") + 1) || "index.html";
  /* Strip `.html` so it matches Netlify's clean prod URLs (e.g. `/our-work`). */
  return file.replace(/\.html$/, "");
};

const initHeader = async (): Promise<void> => {
  const header = document.getElementById("header");
  if (!header) return;

  /* If the page ships the header markup statically (so the logo paints in the
     first frame instead of after the bundle runs), keep that DOM and only wire
     up interactivity below. Fall back to injecting the partial otherwise. */
  if (!header.querySelector(".dex-header-inner")) {
    header.innerHTML = headerHtml;
  }

  const page = currentPage();
  header.querySelectorAll<HTMLAnchorElement>(".dex-menu a").forEach((a) => {
    const href = (a.getAttribute("href") || "").replace(/\.html$/, "");
    if (href === page) a.setAttribute("aria-current", "page");
  });

  const headerInner = header.querySelector(".dex-header-inner");
  if (!headerInner) return;

  const burger = document.createElement("button");
  burger.type = "button";
  burger.className = "dex-header-burger";
  burger.id = "header-burger";
  burger.setAttribute("aria-label", "Open menu");
  burger.setAttribute("aria-expanded", "false");
  burger.setAttribute("aria-controls", "header-mobile");
  for (let i = 0; i < 3; i++) {
    const bar = document.createElement("span");
    bar.className = "dex-header-burger__bar";
    bar.setAttribute("aria-hidden", "true");
    burger.appendChild(bar);
  }
  headerInner.appendChild(burger);

  const scrim = document.createElement("div");
  scrim.className = "dex-header-scrim";
  scrim.id = "header-scrim";
  scrim.setAttribute("aria-hidden", "true");
  header.appendChild(scrim);

  const mobile = document.createElement("div");
  mobile.className = "dex-header-mobile";
  mobile.id = "header-mobile";
  mobile.setAttribute("role", "dialog");
  mobile.setAttribute("aria-modal", "true");
  mobile.setAttribute("aria-label", "Site navigation");
  mobile.setAttribute("aria-hidden", "true");

  const nav = document.createElement("nav");
  nav.className = "dex-header-mobile__nav";
  nav.setAttribute("aria-label", "Primary");
  NAV_ITEMS.forEach((item) => {
    const a = document.createElement("a");
    a.href = item.href;
    a.textContent = item.label;
    nav.appendChild(a);
  });
  mobile.appendChild(nav);

  const cta = document.createElement("button");
  cta.type = "button";
  cta.className = "dex-btn dex-btn-dark dex-header-mobile__cta";
  cta.setAttribute("data-open-schedule-modal", "");
  cta.textContent = "Get started";
  mobile.appendChild(cta);

  header.appendChild(mobile);

  let navScrollY = 0;

  const setOpen = (o: boolean) => {
    if (o) {
      navScrollY = window.scrollY;
      document.body.style.top = `-${navScrollY}px`;
    }
    header!.classList.toggle("dex-header--nav-open", o);
    document.body.classList.toggle("nav-open", o);
    burger.setAttribute("aria-expanded", o ? "true" : "false");
    burger.setAttribute("aria-label", o ? "Close menu" : "Open menu");
    mobile.setAttribute("aria-hidden", o ? "false" : "true");
    scrim.setAttribute("aria-hidden", o ? "false" : "true");
    if (o) {
      const first = mobile.querySelector("a");
      if (first) requestAnimationFrame(() => first.focus());
    } else {
      document.body.style.top = "";
      window.scrollTo(0, navScrollY);
    }
  };

  burger.addEventListener("click", () => {
    setOpen(!header!.classList.contains("dex-header--nav-open"));
  });

  scrim.addEventListener("click", () => setOpen(false));

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && header!.classList.contains("dex-header--nav-open")) {
      setOpen(false);
    }
  });

  window.addEventListener("resize", () => {
    if (window.innerWidth >= 768 && header!.classList.contains("dex-header--nav-open")) {
      setOpen(false);
    }
  });

  mobile.querySelectorAll("a").forEach((a) => {
    a.addEventListener("click", () => setOpen(false));
  });
};

initHeader();

{
  const headerEl = document.getElementById("header");
  if (headerEl) {
    window.addEventListener(
      "scroll",
      () => {
        headerEl.classList.toggle("scrolled", window.scrollY > 6);
      },
      { passive: true }
    );
  }
}
